export const CAR_PRIZE_JUN_26_URL = '/car-prize-draw';
